'use client';

import type { CreateToasterProps } from '@chakra-ui/react';
import { toaster } from '../components/ui';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export type ToastOption = {
	title: 	      string;
	description?: string;
	placement?:   CreateToasterProps['placement'];
	duration?:    number;
};

function createToastOption(type: ToastType, option: ToastOption) {
  return {
    ...option,
    placement: option.placement || 'top-end',
    duration:  1500,
    type,
  };
}

export const useToast = () => {
	const showSuccess = (toasterProps: ToastOption) => {
		const options = createToastOption('success', toasterProps);
		toaster.create(options);
	};

	const showError = (toasterProps: ToastOption) => {
		const options = createToastOption('error', toasterProps);
		toaster.create(options);
	};

	const showInfo = (toasterProps: ToastOption) => {
		const options = createToastOption('info', toasterProps);
		toaster.create(options);
	};

	const showWarning = (toasterProps: ToastOption) => {
		const options = createToastOption('warning', toasterProps);
		toaster.create(options);
	};

	return {
		showSuccess,
		showError,
		showInfo,
		showWarning,
	};
};